import { render, staticRenderFns } from "./consignementTypeList.vue?vue&type=template&id=2c4047bc&"
import script from "./consignementTypeList.vue?vue&type=script&lang=js&"
export * from "./consignementTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports